import { render, staticRenderFns } from "./straw.vue?vue&type=template&id=f6fde8ee"
import script from "./straw.vue?vue&type=script&lang=js"
export * from "./straw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports